<template>
  <van-popup
    v-if="data"
    :close-on-click-overlay="false"
    :value="visible"
    position="top"
    :style="{ top: getPopupTop + 'px' }"
  >
    <div class="notice-title" v-html="data.title"></div>
    <div class="notice-date" v-if="type !== 'night'">{{ (data.up_time || data.add_time) | dateFormat }}</div>
    <div class="notice-content" v-html="escape2Html(data.content)" @click="handleClick"></div>
    <div v-if="data.to_next === 1" class="notice-ok-btn">
      <span @click="handleNotice(2)">
        {{ $t('im.我知道了') }}
      </span>
      <span @click="handleNotice(1)">
        {{ $t('im.继续') }}
        {{ (timeNum && timeNum > 0) ? `(${timeNum})` : null }}
      </span>
    </div>
    <div v-else class="notice-ok-btn" @click="handleNotice(2)">
      {{ $t('im.我知道了') }}
      {{ (timeNum && timeNum > 0) ? `(${timeNum})` : null }}
    </div>
  </van-popup>
</template>

<script>
  import { escape2Html } from '@/utils/util';

  export default {
    name: 'ImNotice',
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      data: {
        type: Object,
        default: () => ({})
      },
      type: {
        type: String,
        default: 'im'
      }
    },
    watch: {
      visible: {
        handler (val) {
          if (val) {
            this.initData();
          }
        },
        immediate: true
      }
    },
    data () {
      return {
        timer: null,
        timeNum: 0
      };
    },
    computed: {
      getPopupTop() {
        // return Math.floor(this.outerWidth / 375 * 44);
        return 44;
      }
    },
    methods: {
      escape2Html,
      initData () {
        const timeNum = (this.data && this.data.wait_time) || 0;
        this.timeNum = timeNum;
        if (timeNum && timeNum > 0) {
          this.setTimer();
        }
      },
      handleNotice (type) {
        if (this.timeNum && this.timeNum > 0) {
          return;
        }

        if (type === 2) {
          this.$emit('close');
        } else {
          this.$emit('ok');
        }
      },
      setTimer () {
        this.timer = setInterval(() => {
          this.timeNum = this.timeNum - 1;
          if (this.timeNum <= 0) {
            clearInterval(this.timer);
          }
        }, 1000);
      },
      handleClick (e) {
        e.preventDefault();
        // if (e.target.id === 'feedback-btn') {
        //   this.$emit('feedBack');
        // }
        const { tagName, innerText } = e.target;
        if (tagName.toLowerCase() === 'a' && innerText === '我要反馈') {
          this.$emit('feedBack');
        }
      }
    }
  };
</script>

<style lang="less" scoped>
.notice-title {
  font-size: 16px;
  padding: 10px;
}

.notice-date {
  padding: 0 10px;
  color: #999;
  font-size: 12px;
}

.notice-content {
  padding: 10px;
  color: #666;
  font-size: 14px;
  height: 25vh;
  .scrollMinXin(hidden, auto);

}

.notice-ok-btn {
  width: 100%;
  height: 40px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-top: 1px solid #F7F7F7;
  color: @red;
}
</style>